import { Box, Grid, InputAdornment } from "@mui/material";
import { useFormik } from "formik";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomRequiredInputLabel,
  CustomTextFeild,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import { PersonSearch } from "@mui/icons-material";
import ReportsSearchDevotee from "../ReportsSearchDevotee/ReportsSearchDevotee";
import { useEffect, useState } from "react";
import apiPath from "../../../config/apiPaths.json";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import toast from "react-hot-toast";
import ErrorPopup from "../../common/ErrorPopup";
import CustomSelectField from "../../CompactCustomComponents/CustomSelectField";
import CustomDatePickerField from "../../CompactCustomComponents/CustomDatePickerField";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import dayjs from "dayjs";

const VastraReport = ({ sendDataToParent, getReportData }: any) => {
  const initialValues = {
    signInName: "",
    vastra: "",
    vastraCategory: "",
    vastraExchange: "",
    fromDate: dayjs().subtract(7, 'day').format("YYYY-MM-DD"),
    toDate: dayjs().format("YYYY-MM-DD"),
    deity: "",
  };

  const vastraCategoryList = [
    {
      value: "Own",
      label: "Own",
    },
    {
      value: "Temple",
      label: "Temple",
    },
  ];

  const vastraExchangeList = [
    {
      value: "Return",
      label: "Return",
    },
    {
      value: "No Return",
      label: "No Return",
    },
  ];
  const [openSearchDevotee, setOpenSearchDevotee] = useState(false);
  const [vastrasList, setVastrasList] = useState<any>([]);
  const [deitiesList, setDeitiesList] = useState<any>([]);
  const [formData, setFormData] = useState(initialValues);
  const [loading, setLoading] = useState<boolean>(false);

  const getVastrasList = async () => {
    await apiRequest({
      method: "GET",
      endpoint: apiPath.vastrasList,
      includeToken: true,
    })
      .then((res) => {
        setVastrasList(res.data);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />
        );
      });
  };

  const getDeitiesList = async () => {
    await apiRequest({
      method: "GET",
      endpoint: apiPath.deitiesList,
      includeToken: true,
    })
      .then((res) => {
        setDeitiesList(res.data);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />
        );
      });
  };

  useEffect(() => {
    getVastrasList();
    getDeitiesList();
  }, [formData.vastra, formData.deity]);

  const handleFieldChange = (field: any, value: any) => {
    if (field === "fromDate" || field === "toDate") {
      const formattedDate = dayjs(value, "YYYY-MM-DD");
      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("YYYY-MM-DD")
          : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };


  const handleOpenSearchDevoteeDialog = () => {
    setOpenSearchDevotee(true);
  };

  const handleClose = () => {
    setOpenSearchDevotee(false);
  };

  const hanldeSelectUser = (username: string) => {
    handleFieldChange("signInName", username?.toUpperCase());
    handleClose();
  };

  const renderSignInNameField = () => {
    return (
      <CustomTextFeild
        fullWidth
        className="text_field compact_fields bg_white"
        value={formData.signInName}
        onChange={(e) => {
          handleFieldChange("signInName", e.target.value);
        }}
        onBlur={(e) => {
          const inputUserName = e.target.value.toUpperCase();
          handleFieldChange("signInName", inputUserName);
        }}
        name="signInName"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <PersonSearch
                sx={{ ml: "10px", cursor: "pointer", color: "#F05802" }}
                onClick={handleOpenSearchDevoteeDialog}
              />
            </InputAdornment>
          ),
        }}
      />
    );
  };

  const renderVastraReportFields = () => {
    return (
      <Box sx={{ maxWidth: "450px" }}>
        <Grid container columnSpacing={"12px"}>
          <Grid item xs={12} sm={6}>
            {CustomRequiredInputLabel("Sign-in Name", false)}
            {renderSignInNameField()}
          </Grid>
          <Grid item xs={12} sm={6}>
            {CustomRequiredInputLabel("Vastra", false)}
            <CustomSelectField
              handleDropdownChange={handleFieldChange}
              errorMessage={undefined}
              dropDownList={vastrasList}
              value={formData.vastra}
              fieldName={"vastra"}
              placeholder={"Select vastra"}
              optionLabel={"vastraName"}
              optionValue={"vastraPurposeId"}
              overrideStyles={{ backgroundColor: "white" }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          columnSpacing={"12px"}
          rowSpacing={"10px"}
          sx={{ mt: 0 }}
        >
          <Grid item xs={12} sm={6}>
            {CustomRequiredInputLabel("Vastra Category", false)}
            <CustomSelectField
              handleDropdownChange={handleFieldChange}
              errorMessage={undefined}
              dropDownList={vastraCategoryList}
              value={formData.vastraCategory}
              fieldName={"vastraCategory"}
              placeholder={"Select vastra category"}
              optionLabel={"label"}
              optionValue={"value"}
              overrideStyles={{ backgroundColor: "white" }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {CustomRequiredInputLabel("Vastra Exchange", false)}
            <CustomSelectField
              handleDropdownChange={handleFieldChange}
              errorMessage={undefined}
              dropDownList={vastraExchangeList}
              value={formData.vastraExchange}
              fieldName={"vastraExchange"}
              placeholder={"Select vastra exchange"}
              optionLabel={"label"}
              optionValue={"value"}
              overrideStyles={{ backgroundColor: "white" }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          columnSpacing={"12px"}
          rowSpacing={"10px"}
          sx={{ mt: 0 }}
        >
          <Grid item xs={12} sm={6}>
            {CustomRequiredInputLabel("Search By Receipt Date From", false)}
            <CustomDatePickerField
              date={formData.fromDate}
              handleDateChange={handleFieldChange}
              errorMessage={undefined}
              name="fromDate"
              format="YYYY-MM-DD"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {CustomRequiredInputLabel("Search By Receipt Date To", false)}
            <CustomDatePickerField
              date={formData.toDate}
              handleDateChange={handleFieldChange}
              errorMessage={undefined}
              name="toDate"
              format="YYYY-MM-DD"
            />
          </Grid>
        </Grid>
        <Grid
          container
          columnSpacing={"12px"}
          rowSpacing={"10px"}
          sx={{ mt: 0 }}
        >
          <Grid item xs={12} sm={6}>
            {CustomRequiredInputLabel("Search By Deity", false)}
            <CustomSelectField
              handleDropdownChange={handleFieldChange}
              errorMessage={undefined}
              dropDownList={deitiesList}
              value={formData.deity}
              fieldName={"deity"}
              placeholder={"Select deity"}
              optionLabel={"deityName"}
              optionValue={"id"}
              overrideStyles={{ backgroundColor: "white" }}
            />
          </Grid>
        </Grid>
      </Box>
    );
  };

  const handleClear = () => {
    setFormData(initialValues);
  };

  const getVatsraReport = () => {
    const reqBody = {
      ...(formData.signInName && {
        searchUserName: formData.signInName.toUpperCase(),
      }),
      ...(formData.vastra && { vastrasPurposeId: formData.vastra }),
      ...(formData.vastraCategory && { vastraCategory: formData.vastraCategory }),
      ...(formData.vastraExchange && { vastraExchange: formData.vastraExchange }),
      ...(formData.fromDate && { searchStartDate: formData.fromDate }),
      ...(formData.toDate && { searchEndDate: formData.toDate }),
      ...(formData.deity && { deityId: formData.deity }),
      pagination: true,
      pageNumber: 1,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/treasury/VASTRA_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, { reqBody,
          totalDonatedAmount:res.data.totalDonatedAmount,
          totalElements:res.data.totalElements,
          pageSize:res.data.pagesize });
        const response = res.data.data.map((report: any,index:number) => {
          return {
            "Sr.No.":index+1,
            "Receipt Number": report.receiptnumber,
            "Reference Number": report.referencenumber,
            "Name (Sign-in)": report.name,
            "Mode of Payment": report.donationtype,
            "Check Number": report.checknumber,
            "Vastra Type": report.vastratype,
            "Date of Donation": report.dateofdonation,
            Amount: formatAmount(report.amount),
          };
        });
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const renderButtonsComponent = () => {
    return (
      <Box sx={{ mt: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px", mr: "16px" }}
          onClick={getVatsraReport}
          disabled={loading}
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Box>
    );
  };
  return (
    <>
      {renderVastraReportFields()}
      {renderButtonsComponent()}
      {openSearchDevotee && (
        <ReportsSearchDevotee
          open={openSearchDevotee}
          handleClose={handleClose}
          hanldeSelectUser={hanldeSelectUser}
        />
      )}
    </>
  );
};

export default VastraReport;
